import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGeneralelectricComponent } from './simple-icons-generalelectric.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGeneralelectricComponent ],
    exports:      [ SimpleIconsGeneralelectricComponent ],
    bootstrap:    []
})
export class SimpleIconsGeneralelectricModule {}
